<div *ngIf='componentReady' class='SendToCampaign'>
  <div [formGroup]='inputForm' class='container'>
    <div class='mb-5 pt-3'>
      <mat-radio-group (change)='changeChoice($event)' formControlName='choice'>
        <mat-radio-button value='0'>Send to campaign</mat-radio-button>
        <mat-radio-button class='ms-3' value='1'>Detach from current campaign</mat-radio-button>
      </mat-radio-group>
    </div>
    <ng-container *ngIf='choice === "0"; else detach'>
      <div class='row'>
        <div class='col-6 d-flex align-items-center'>Select campaign:</div>
        <div class='col-6'>
          <app-select
            [items]='getCampaignsSelectItems()'
            formControlName='campaign_id'
            label='Campaign'></app-select>
          <mat-error
            *ngIf='(campaignId.touched || campaignId.dirty) && campaignId.errors'>
          <span *ngIf='campaignId.errors?.required' class='text-danger'
          >Please, select a campaign</span
          >
          </mat-error>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col-6 d-flex align-items-center'>Select start date</div>
        <div class='col-6'>
          <app-text-field
            [datePickerStartDate]='getStartDate()'
            datePickerType='calendar'
            formControlName='start_date'
            placeholder='Start Date'
            type='date'></app-text-field>
          <mat-error
            *ngIf='(startDate.touched || startDate.dirty) && startDate.errors'>
          <span *ngIf='startDate.errors?.required' class='text-danger'
          >Please, select a campaign</span
          >
          </mat-error>
        </div>
      </div>
    </ng-container>
    <ng-template #detach>
      <div class='alert alert-warning'>
        <p>When contact group is detached from a running campaign, no campaign emails will be sent to the contacts
          within the group. Please note, if you are in sending time and campaign emails are scheduled, the contacts will
          receive the currently scheduled templates. Changes, either send group to different campaign or detach group
          from campaign will be in force for the next round of emails.</p>
      </div>
    </ng-template>
  </div>
</div>
